import moment from "moment";
import { nanoid } from "nanoid";
import { formatPrice } from "../../../utils/formatPrice";
import { Typography, Box, Paper, Stack } from "@mui/material";
import { convertToFormattedAmount } from "../../../utils/convertAmount";
import type { IncomeSourceInterface } from "../../../interfaces/mortgageDetailsInterface";

export const IncomeSources = (
  incomeSources: IncomeSourceInterface[] | undefined
) => {
  if (!incomeSources) {
    return (
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ mt: 4 }}
      >
        No income sources available.
      </Typography>
    );
  }
  return (
    <Box>
      {incomeSources.map((income) => (
        <Paper
          key={nanoid()}
          elevation={3}
          sx={{
            borderRadius: "12px",
            padding: 3,
            mb: 3,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s, box-shadow 0.3s",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)"
            }
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h6" color="primary">
              {income.type?.replace(/_/g, " ") || "Unknown Type"}
            </Typography>
            {income.employerName && (
              <Typography variant="body1">
                <strong>Employer Name:</strong> {income.employerName}
              </Typography>
            )}
            {income.businessName && (
              <Typography variant="body1">
                <strong>Business Name:</strong> {income.businessName}
              </Typography>
            )}

            {income.propertyType && (
              <Typography variant="body1">
                <strong>Property Type:</strong> {income.propertyType}
              </Typography>
            )}
            {income.propertyType && (
              <Typography variant="body1">
                <strong>Property Type:</strong> {income.propertyType}
              </Typography>
            )}
            {income.incomeType && (
              <Typography variant="body1">
                <strong>Income Type:</strong> {income.incomeType}
              </Typography>
            )}
            {income.jobTitle && (
              <Typography variant="body1">
                <strong>Job Title:</strong> {income.jobTitle}
              </Typography>
            )}
            {income.startDate && (
              <Typography variant="body1">
                <strong>Start Date:</strong>{" "}
                {moment(income.startDate).format("YYYY-MM-DD")}
              </Typography>
            )}
            {income.annualBasePay && (
              <Typography variant="body1">
                <strong>Annual Base Pay:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualBasePay.amount)
                )}
              </Typography>
            )}
            {income.annualBonuses && (
              <Typography variant="body1">
                <strong>Annual Bonuses:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualBonuses.amount)
                )}
              </Typography>
            )}
            {income.annualOvertime && (
              <Typography variant="body1">
                <strong>Annual Overtime:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualOvertime.amount)
                )}
              </Typography>
            )}
            {income.annualCommission && (
              <Typography variant="body1">
                <strong>Annual Commission:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualCommission.amount)
                )}
              </Typography>
            )}
            {income.annualIncome && (
              <Typography variant="body1">
                <strong>Annual Income:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualIncome.amount)
                )}
              </Typography>
            )}
            {income.annualAmount && (
              <Typography variant="body1">
                <strong>Annual Amount:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.annualAmount.amount)
                )}
              </Typography>
            )}
            {income.propertyAddress && (
              <Typography variant="body1">
                <strong>Property Address:</strong>{" "}
                {`${income.propertyAddress.address1}, ${income.propertyAddress.city}, ${income.propertyAddress.province}, ${income.propertyAddress.postalCode}, ${income.propertyAddress.country}`}
              </Typography>
            )}
            {income.propertyValue && (
              <Typography variant="body1">
                <strong>Property Value:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.propertyValue.amount)
                )}
              </Typography>
            )}
            {income.monthlyRent && (
              <Typography variant="body1">
                <strong>Monthly Rent:</strong> $
                {formatPrice(
                  convertToFormattedAmount(income.monthlyRent.amount)
                )}
              </Typography>
            )}
            {income.rentalIncomeSince && (
              <Typography variant="body1">
                <strong>Rental Income Since:</strong>{" "}
                {moment(income.rentalIncomeSince).format("YYYY-MM-DD")}
              </Typography>
            )}
            {income.dateEstablished && (
              <Typography variant="body1">
                <strong>Date Established:</strong>{" "}
                {moment(income.dateEstablished).format("YYYY-MM-DD")}
              </Typography>
            )}
            {income.operatingType && (
              <Typography variant="body1">
                <strong>Operating Type:</strong> {income.operatingType}
              </Typography>
            )}
          </Stack>
        </Paper>
      ))}
    </Box>
  );
};
